// | ------------------------------------------------------------------------
// | Dropdown On Hover
// | ------------------------------------------------------------------------ 


import { OverlayScrollbars } from 'overlayscrollbars';

import { Tab } from "bootstrap";

var dropdownMenu = function(){

    var windowWidth = document.body.clientWidth;

    if(windowWidth > 767){

        var navItem = document.getElementsByClassName('dropdown');

        for(var i =0; i< navItem.length; i++){
            navItem[i].onmouseenter = function() {
                 
                this.classList.add("show")
                this.querySelector(".dropdown-toggle").setAttribute("aria-expanded", "true")
                this.querySelector(".dropdown-menu").classList.add("show")

                
                // Add custom scroll bar to the tab links when needed
                var navScroll  = OverlayScrollbars(document.querySelector('.nav-products-tabs'), {
                    overflow: {
                    x: 'hidden',
                    },
                    scrollbars: {
                    visibility: 'visible',
                    autoHide: 'never',
                    }
                }); 
                
                // Add scroll shadows when needed
                var navScrollElement  = document.querySelector('.nav-products-tabs');
                
                const { viewport } = navScroll.elements();
                const { scrollLeft, scrollTop } = viewport;
        
                // Check if bottom shadow required when menu opens
                if((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight){
                    navScrollElement.classList.add('scrollbottom');
                } else{
                    navScrollElement.classList.remove('scrollbottom');
                }

                // Add remove shadows as required on scroll
                viewport.onscroll = (event) => { 
                    if(viewport.scrollTop > 0){
                        navScrollElement.classList.remove('scrolltop');
                    }else{
                        navScrollElement.classList.add('scrolltop');
                    }
    
                    if((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight){
                        navScrollElement.classList.add('scrollbottom');
                    } else{
                        navScrollElement.classList.remove('scrollbottom');
                    }
                }                                

                // Add custom scroll bar to the filters when needed
                const paneScroll  = OverlayScrollbars(document.querySelector('.nav-products'), {
                    overflow: {
                    x: 'hidden',
                    },
                    scrollbars: {
                    visibility: 'visible',
                    autoHide: 'never',
                    }
                }); 

                function navProducts(){

                    console.log("navProducts has ran");
                    
                    // Add scroll shadows when needed
                    var navScrollElement  = document.querySelector('.nav-products');
                    
                    const { viewport } = paneScroll.elements();
                    const { scrollLeft, scrollTop } = viewport;
            
                    // Check if bottom shadow required when menu opens
                    if((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight){
                        navScrollElement.classList.add('scrollbottom');
                    } else{
                        navScrollElement.classList.remove('scrollbottom');
                    }

                    // Add remove shadows as required on scroll
                    viewport.onscroll = (event) => { 
                        if(viewport.scrollTop > 0){
                            navScrollElement.classList.remove('scrolltop');
                        }else{
                            navScrollElement.classList.add('scrolltop');
                        }
        
                        if((viewport.scrollTop + viewport.clientHeight) >= viewport.scrollHeight){
                            navScrollElement.classList.add('scrollbottom');
                        } else{
                            navScrollElement.classList.remove('scrollbottom');
                        }
                    }                 

                }

                navProducts();


                var navTabs = document.querySelectorAll('.tab-btn');

                navTabs.forEach(function (navTab) {

                    navTab.addEventListener('shown.bs.tab', event => {
                        console.log('tab opened');
                        navProducts();
                    })

                });

            }
            navItem[i].onmouseleave = function() { 
                this.classList.remove("show")
                this.querySelector(".dropdown-toggle").setAttribute("aria-expanded", "false")
                this.querySelector('.dropdown-menu').classList.remove("show")
            }
        }

        //var scrollElement = document.querySelector('.prod-nav-grid');
        //const { viewport } = .elements(scrollElement);
        //const { scrollLeft, scrollTop } = viewport; // get scroll offset
        //viewport.scrollTo({ top: 0 }); // set scroll offset

        //var scrollTopPos = viewport.scrollTop;
        
        //var scrollElement = document.querySelector('.prod-nav-grid');
        //var scrollTopPos = scrollElement.scrollTop;

        //console.log(scrollTopPos);


        //const { viewport } = scrollElement.querySelector('.os-viewport')
        //const { viewport } = isInstance.elements('.prod-nav-grid')
        //const { scrollTop } = viewport; // get scroll offset

        

    }

}

// Run on scroll/load/resize
window.addEventListener("scroll", dropdownMenu, false);
window.addEventListener("load", dropdownMenu, false);
window.addEventListener("resize", dropdownMenu, false);


